import { render, staticRenderFns } from "./BDXEditFormAccountName.vue?vue&type=template&id=0563a47a&scoped=true"
import script from "./BDXEditFormAccountName.vue?vue&type=script&lang=js"
export * from "./BDXEditFormAccountName.vue?vue&type=script&lang=js"
import style0 from "./BDXEditFormAccountName.vue?vue&type=style&index=0&id=0563a47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563a47a",
  null
  
)

export default component.exports